export default "__VITE_ASSET__c88eefbe__"